export default __webpack_public_path__ + "static/media/790246060236079165.8950d68a.png";